var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46967 11.4817L2.73532 9.74441L1 11.4817M16.616 7L18.3503 8.73826L20.0856 7",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3494 8.73819C18.3494 6.66324 17.5272 4.6754 16.063 3.20825C15.3384 2.48232 14.4778 1.90638 13.5305 1.51339C12.5831 1.1204 11.5675 0.918067 10.5419 0.917978C9.54549 0.916422 8.55829 1.10821 7.63498 1.48272C6.60392 1.89591 5.6729 2.52435 4.9041 3.32607C4.13529 4.12778 3.54641 5.08432 3.17677 6.13178M2.73438 9.74337C2.73563 11.5586 3.36776 13.3169 4.52255 14.7174C5.67554 16.1168 7.28017 17.0707 9.06042 17.4149C10.8407 17.7591 12.6852 17.4722 14.2768 16.6034C15.8692 15.7344 17.1097 14.3386 17.7856 12.6551",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17578 11.1603C8.22648 11.7415 8.50283 12.2796 8.94558 12.6594C9.38834 13.0392 9.96227 13.2305 10.5444 13.1922C12.4549 13.1922 12.9129 12.0931 12.9129 11.1603C12.9129 10.2276 12.1231 9.23903 10.5444 9.23903C8.96563 9.23903 8.17578 8.61458 8.17578 7.34221C8.19824 6.90146 8.35413 6.47795 8.6228 6.12783C8.89146 5.77771 9.2602 5.51753 9.68012 5.38177C9.95906 5.29173 10.2527 5.25943 10.5444 5.28684C11.1272 5.26127 11.6976 5.46014 12.1383 5.84249C12.5789 6.22485 12.8561 6.76159 12.9129 7.34221M10.5444 14.3765V13.3478M10.5444 4.09863V5.28292",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar_sign.5b955fd6058154728bee285fd541f303.svg";
export { ForwardRef as ReactComponent };